import { connect } from 'react-redux';

import { isCurrentAppDefinitionSaving } from 'app/developer-v3/selectors';

import ActionDynamicInputEditorWrapper from './ActionDynamicInputEditorWrapper';

const mapStateToProps = state => ({
  isSaving: isCurrentAppDefinitionSaving(state),
});

export default connect(mapStateToProps)(ActionDynamicInputEditorWrapper);
